export interface CultureFilterType {
  selectedLCIDs: server.dto.LCID[]
}

export const getSortedLCIDs = (filter: CultureFilterType) => {
  return [...filter.selectedLCIDs].sort((a, b) => getCulture(a).text.localeCompare(getCulture(b).text));
};

export const getCulture = (lcid: server.dto.LCID): server.dto.Culture => {
  return serverReference.cultures.find(
    (c) => c.value === lcid
  );
};

export const getLabel = (lcid: server.dto.LCID) => {
  return getCulture(lcid).text;
};

export const initialCultureFilter: CultureFilterType = {
  selectedLCIDs: []
};
